import { GAME_API } from "@/constants/constants"
import { io } from "socket.io-client"

const url = new URL(GAME_API)



const clientSingleton = () => {
  return io(url.origin, {
    autoConnect: false,
    withCredentials: false,
    transports: ['websocket'],
    path: url.pathname + '/socket.io',
  });
}

declare global {
  var io: undefined | ReturnType<typeof clientSingleton>
}

const socket = globalThis.io ?? clientSingleton()

export default socket

globalThis.io = socket
